<input 
    #input 
    class="input" 
    [id]="id" 
    [type]="type" 
    [attr.maxlength]="maxlength" 
    [attr.placeholder]="placeholder"
    [readonly]="readonly" 
    [attr.min]="min" 
    [attr.max]="max" 
    [attr.inputmode]="inputmode"
    [attr.autocomplete]="autocomplete"
    (change)="keyUp.next($event)"
    (keyup)="keyUp.next($event)" 
    (focus)="onFocusEvent(true, $event)"
    (focusout)="onFocusEvent(false, $event)"
    *ngIf="type !== 'textarea' && !mask"
  />

<input 
    #input 
    class="input" 
    [id]="id" 
    [type]="type" 
    [attr.maxlength]="maxlength" 
    [attr.placeholder]="placeholder"
    [readonly]="readonly" 
    [attr.min]="min" 
    [attr.max]="max" 
    [mask]="mask"
    [step]="numStep" 
    [attr.inputmode]="inputmode"
    [attr.autocomplete]="autocomplete"
    (change)="keyUp.next($event)"
    (keyup)="keyUp.next($event)" 
    (focus)="onFocusEvent(true, $event)"
    (focusout)="onFocusEvent(false, $event)"
    *ngIf="type !== 'textarea' && mask"
  />

<textarea 
    #input 
    class="input" 
    [id]="id" 
    [attr.placeholder]="placeholder"
    [readonly]="readonly" 
    (change)="keyUp.next($event)"
    (keyup)="keyUp.next($event)" 
    (focus)="onFocusEvent(true, $event)"
    (focusout)="onFocusEvent(false, $event)" 
    *ngIf="type === 'textarea'"
  ></textarea>

<ng-template [ngIf]="arrows && !isDisabled">
  <button type="button" [disabled]="!canDecrement" (click)="changeValue(-1)" class="minus order-first"></button>
  <button type="button" [disabled]="!canIncrement" (click)="changeValue(1)" class="plus order-last"></button>
</ng-template>

<ng-content select="i,span"></ng-content>